import { SMSStateItem, SMS_ACTION_TYPE } from 'store/sms/sms.type';

export const SMS_INIT: SMSStateItem = {
  refId: '',
  actionType: SMS_ACTION_TYPE.SMS,
  id: '',
  name: '',
  stepIdx: -1,
};
